import { CloseButton, Menu } from '@mantine/core';
import { IconLock, IconMenu4 } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { defaultIconStyle } from '../theme/styling/iconStyling';

interface TableRowMenuProps {
	children: ReactNode;
	disabled?: boolean;
}

export function TableRowMenu({
	children,
	disabled = false,
}: TableRowMenuProps) {
	return (
		<Menu shadow="md" width={200} position={'bottom-end'}>
			<Menu.Target>
				<CloseButton
					icon={
						!disabled ? (
							<IconMenu4 {...defaultIconStyle} />
						) : (
							<IconLock {...defaultIconStyle} />
						)
					}
					data-cy={'menu-button'}
					disabled={disabled}
				/>
			</Menu.Target>
			<Menu.Dropdown>{children}</Menu.Dropdown>
		</Menu>
	);
}
